// Simple attribution capture and persistence with expiration.
// Stores the original landing UTM parameters and ad click ids, and exposes getters.

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
// Paid-ad click identifiers (Google, Meta, Microsoft) captured alongside UTM.
const CLICK_ID_KEYS = ['gclid', 'fbclid', 'msclkid', 'gad_source']
const ATTRIBUTION_KEYS = [...UTM_KEYS, ...CLICK_ID_KEYS]
const STORAGE_KEY = 'yumnia:utm'
const DEFAULT_TTL_MS = 7 * 24 * 60 * 60 * 1000 // 7 days

function parseUtmFromUrl(urlSearch) {
  const params = new URLSearchParams(
    urlSearch || (typeof window !== 'undefined' ? window.location.search : '')
  )
  const out = {}
  let found = false
  for (const key of ATTRIBUTION_KEYS) {
    const val = params.get(key)
    if (val) {
      out[key] = val
      found = true
    }
  }
  return found ? out : null
}

export function captureAndStoreUtm(ttlMs = DEFAULT_TTL_MS) {
  try {
    const utm = parseUtmFromUrl()
    if (!utm) return null
    const record = {
      utm,
      storedAt: Date.now(),
      expiresAt: Date.now() + (typeof ttlMs === 'number' ? ttlMs : DEFAULT_TTL_MS),
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record))
    return utm
  } catch (_) {
    return null
  }
}

export function getStoredUtm() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const record = JSON.parse(raw)
    if (record && typeof record === 'object') {
      if (record.expiresAt && Date.now() < record.expiresAt && record.utm) {
        return record.utm
      }
      // expired
      localStorage.removeItem(STORAGE_KEY)
    }
  } catch (_) {
    // ignore parse/storage errors
  }
  return null
}

export function clearStoredUtm() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (_) {
    /* ignore */
  }
}

/** Flat object of UTM params safe to merge into GA4 event params (non-PII, bounded length). */
export function gaDimensionsFromStoredUtm () {
  const utm = getStoredUtm()
  if (!utm || typeof utm !== 'object') return {}
  const out = {}
  for (const [k, v] of Object.entries(utm)) {
    if (v == null) continue
    const s = String(v).trim()
    if (s && s.length <= 120) out[k] = s
  }
  return out
}
